/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JwtToken } from '../models/JwtToken';
import type { PostAccessTokenRenewRequest } from '../models/PostAccessTokenRenewRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TokensService {
    /**
     * @returns JwtToken OK
     * @throws ApiError
     */
    public static postAccessTokenRenewAdmin({
        requestBody,
    }: {
        requestBody?: PostAccessTokenRenewRequest,
    }): CancelablePromise<JwtToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/tokens/public/renew-access-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
